import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "..";

export interface IDebug {
  isDebugging: boolean;
}

const initialState = {
  isDebugging: false,
} as IDebug;

export const debugSlice = createSlice({
  name: "debug",
  initialState,
  reducers: {
    startDebugging: (state) => {
      state.isDebugging = true;
    },
    stopDebugging: (state) => {
      state.isDebugging = false;
    },
    toggleDebugging: (state) => {
      state.isDebugging = !state.isDebugging;
    },
  },
});

export const { startDebugging, stopDebugging, toggleDebugging } =
  debugSlice.actions;

export const selectIsDebugging = (state: RootState) => state.debug.isDebugging;
